import React from 'react';
import { Dropdown, DropdownItem } from '../../../dropdown';
import { CHAT_GROUP_TYPE } from '../../../../global/constants';
import { ChatGroupInterface, UserInterface } from '../../../../interfaces/chatMessageInterface';

interface WorkspaceInterface {
  isAdmin?: boolean;
  isOwner?: boolean;
  id?: string;
}

interface ChatGroupDropdownProps {
  chatGroupType: number | undefined;
  currentChatGroup: ChatGroupInterface | null;
  currentUser: UserInterface | null;
  currentWorkspace: WorkspaceInterface | null;
  onPinChatGroup: () => void;
  onOpenEditGroupModal: () => void;
  onOpenClearMessageConfirmation: () => void;
  onRemoveMember: (userId: string) => void;
  onMenuItemClick?: (key: number | string) => void;
  renderMoreIcon: () => React.ReactNode;
}

export const ChatGroupDropdown: React.FC<ChatGroupDropdownProps> = ({
  chatGroupType,
  currentChatGroup,
  currentUser,
  currentWorkspace,
  onPinChatGroup,
  onOpenEditGroupModal,
  onOpenClearMessageConfirmation,
  onRemoveMember,
  onMenuItemClick,
  renderMoreIcon
}) => {
  const isProjectChat = chatGroupType === CHAT_GROUP_TYPE.PROJECT;
  const userCount = currentChatGroup?.users?.length || 0;
  const isPinned = currentChatGroup?.pinned;
  const isCreatedByCurrentUser = currentChatGroup?.createdBy === currentUser?.id;
  const isAdminOrOwner = currentWorkspace?.isAdmin || currentWorkspace?.isOwner;
  const canEditGroupName = userCount > 2;
  const canLeaveGroup = userCount > 2;
  const canClearChat = userCount <= 2 || isAdminOrOwner || isCreatedByCurrentUser;

  if (isProjectChat) {
    return (
      <Dropdown modalTitle='Manage Chat' content={renderMoreIcon()} trigger='click' isMinWidth={128}>
        <DropdownItem
          label={isPinned ? 'Unpin chat' : 'Pin chat'}
          onClick={() => {
            onMenuItemClick?.(1);
          }}
        />
        {isAdminOrOwner && (
          <DropdownItem
            label='Clear chat'
            onClick={() => {
              onMenuItemClick?.(2);
            }}
          />
        )}
      </Dropdown>
    );
  }

  return (
    <Dropdown modalTitle='Manage Chat' activeClassName='active-state' content={renderMoreIcon()} isMinWidth={128}>
      <DropdownItem label={isPinned ? 'Unpin chat' : 'Pin chat'} onClick={onPinChatGroup} />
      {canEditGroupName && <DropdownItem label='Edit Group name' onClick={onOpenEditGroupModal} />}
      {canClearChat && <DropdownItem label='Clear chat' onClick={onOpenClearMessageConfirmation} />}
      {canLeaveGroup && (
        <DropdownItem
          label='Leave'
          onClick={() => {
            onRemoveMember(currentUser?.id || '');
          }}
          tone='critical'
        />
      )}
    </Dropdown>
  );
};

export default ChatGroupDropdown;
